const INITIAL_STATE = { registro: {}, modoTela: 'lista', lista: [], listaGranja: [], listaProduto: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'ESTOQUE_AJUSTE_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        case 'ESTOQUE_AJUSTE_LISTADO':
            return { ...state, modoTela: 'lista', lista: action.payload.data };
		case 'ESTOQUE_AJUSTE_GRANJA_SELECT_LISTADO':
            return { ...state, listaGranja: action.payload.data };
		case 'ESTOQUE_AJUSTE_PRODUTO_SELECT_LISTADO':
            return { ...state, listaProduto: action.payload.data };
        default:
            return state;
    }
}
